import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import {
    SpsTableComponent,
    SpsTableBodyComponent,
    SpsTableCellComponent,
    SpsTableHeadComponent,
    SpsTableHeaderComponent,
    SpsTableRowComponent,
} from "../components/index";

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [
        SpsTableComponent,
        SpsTableBodyComponent,
        SpsTableCellComponent,
        SpsTableHeadComponent,
        SpsTableHeaderComponent,
        SpsTableRowComponent,
    ],
    exports: [
        SpsTableComponent,
        SpsTableBodyComponent,
        SpsTableCellComponent,
        SpsTableHeadComponent,
        SpsTableHeaderComponent,
        SpsTableRowComponent,
    ],
})
export class SpsTableModule {}
